import moment from 'moment';
import { INBOX_DATE_FORMAT } from 'pages/report/utils/constants';

export function getDateInInstitutionTZ(institutionTimezone, timestamp, format = INBOX_DATE_FORMAT) {
    // which date format should this be?
    return institutionTimezone ? moment(timestamp).utcOffset(institutionTimezone).format(format) :
        moment(timestamp).format(format);
}